export const fetchLanguages = async (getLanguages, callback) => {
    const translations = await getLanguages();
    callback(translations);
};
